import { post, get } from "shared-utils";
import type { AdditionalCostsData } from "@wayflyer/flyui-dataviz";
import { useLocalStorage } from "shared-ui";
import { addError } from "@wayflyer/blackbox-fe";

const ADDITIONAL_COSTS_KEY = "wayflyer-insights-additional-cost-data-";

export const initialAdditionalCosts: AdditionalCostsData = {
  cogs: 0,
  shipping: 0,
  opex: 0,
  marketing: 0,
};

const storeAdditionalCostsDataInLocalStorage = (additionalCostsPath, additionalCostsData: AdditionalCostsData) => {
  window.localStorage.setItem(ADDITIONAL_COSTS_KEY + additionalCostsPath, JSON.stringify(additionalCostsData));
};

export function getAdditionalCostsData(
  additionalCostsPath: string,
  onSuccess: (data: AdditionalCostsData) => any,
  onFailure: (failureMessage: string) => any
) {
  get(
    additionalCostsPath,
    (data: AdditionalCostsData) => {
      onSuccess(data);
    },
    (failureMessage: string) => {
      addError(new Error(`Error fetching additional costs data: ${failureMessage}`));
      onFailure(failureMessage);
    }
  );
}

export function storeAdditionalCostsData(
  additionalCostsPath: string,
  additionalCostsData: AdditionalCostsData,
  onSuccess: () => any,
  onFailure: (failureMessage: string) => any
) {
  post(
    additionalCostsPath,
    {
      additionalCosts: additionalCostsData,
    },
    onSuccess,
    (failureMessage) => {
      addError(new Error(`Error updating additional costs data: ${failureMessage}`));
      onFailure(failureMessage);
    }
  );
  storeAdditionalCostsDataInLocalStorage(additionalCostsPath, additionalCostsData);
}

export const useAdditionalCosts = (additionalCostsPath) => {
  return useLocalStorage(ADDITIONAL_COSTS_KEY + additionalCostsPath, initialAdditionalCosts, true);
};
